import React from 'react';

const EnvTest = () => {
  // Toutes les variables d'environnement disponibles
  const allEnvVars = Object.keys(process.env)
    .filter(key => key.startsWith('REACT_APP_'))
    .sort();

  const emailJsVars = {
    serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID,
    templateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
    publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
  };

  return (
    <div className="p-8 space-y-6">
      <h1 className="text-3xl font-bold">Test des Variables d'Environnement</h1>

      <div className="bg-gray-100 dark:bg-gray-800 p-4 rounded-lg">
        <h2 className="text-xl font-semibold mb-3">Variables EmailJS :</h2>
        <div className="space-y-2 font-mono text-sm">
          <div>
            <strong>SERVICE_ID:</strong> {emailJsVars.serviceId || '❌ NON DÉFINI'}
          </div>
          <div>
            <strong>TEMPLATE_ID:</strong> {emailJsVars.templateId || '❌ NON DÉFINI'}
          </div>
          <div>
            <strong>PUBLIC_KEY:</strong> {emailJsVars.publicKey || '❌ NON DÉFINI'}
          </div>
        </div>
      </div>

      <div className="bg-blue-100 dark:bg-blue-900 p-4 rounded-lg">
        <h2 className="text-xl font-semibold mb-3">
          Toutes les variables REACT_APP_* ({allEnvVars.length}) :
        </h2>
        <div className="space-y-1 font-mono text-sm max-h-96 overflow-auto">
          {allEnvVars.length === 0 ? (
            <p className="text-red-600 dark:text-red-400">
              ❌ Aucune variable d'environnement trouvée !
            </p>
          ) : (
            allEnvVars.map(key => (
              <div key={key} className="border-b border-gray-300 dark:border-gray-700 py-1">
                <strong>{key}:</strong> {process.env[key]}
              </div>
            ))
          )}
        </div>
      </div>

      <div className="bg-yellow-100 dark:bg-yellow-900 p-4 rounded-lg">
        <h2 className="text-xl font-semibold mb-3">Informations de débogage :</h2>
        <div className="space-y-1 font-mono text-sm">
          <div><strong>NODE_ENV:</strong> {process.env.NODE_ENV}</div>
          <div><strong>PUBLIC_URL:</strong> {process.env.PUBLIC_URL || '(vide)'}</div>
          <div><strong>process.env existe:</strong> {typeof process.env === 'object' ? '✅ OUI' : '❌ NON'}</div>
        </div>
      </div>

      <div className="bg-orange-100 dark:bg-orange-900 p-4 rounded-lg">
        <h2 className="text-xl font-semibold mb-3">Instructions :</h2>
        <ol className="list-decimal list-inside space-y-2">
          <li>Vérifiez que le fichier <code className="bg-white dark:bg-gray-800 px-2 py-1 rounded">.env</code> existe dans <code className="bg-white dark:bg-gray-800 px-2 py-1 rounded">frontend/</code></li>
          <li>Les variables doivent commencer par <code className="bg-white dark:bg-gray-800 px-2 py-1 rounded">REACT_APP_</code></li>
          <li>Redémarrez COMPLÈTEMENT le serveur (pas de hot reload)</li>
          <li>Vérifiez qu'il n'y a pas d'espaces autour du =</li>
        </ol>
      </div>
    </div>
  );
};

export default EnvTest;
